export default __webpack_public_path__ + "static/gamerize-5-a-605def03ef0f53b5ff037ddfab16a5b0.webp";